/** @format */
// import "./index.css";

import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import CircularProgress from "@material-ui/core/CircularProgress";

import CssBaseline from "@material-ui/core/CssBaseline";
import { ApolloProvider } from "@apollo/react-hooks";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@material-ui/core/styles";

import App from "./App";

import * as serviceWorker from "./serviceWorker";
import client from "./graphql/init";
import theme from "./theme";

import "./firebase";

ReactDOM.render(
  <React.StrictMode>
    <CssBaseline />

    <BrowserRouter>
      <Suspense fallback={<CircularProgress />}>
        <ApolloProvider client={client}>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </ApolloProvider>
      </Suspense>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
